<template>
  <b-modal id="modal-1" ref="quotationModal" :visible="isVisible" :title="$t('quotation.quotationLong')" @ok="handleOK" @close="handleCancel">
    <b-container>
      <div class="row dropdown-row" style="padding-bottom: 20px">
        <div class="col-lg-12">
          {{ $t('quotation.text') }}
        </div>
      </div>
      <!--                                    <div v-if="user.isAnonym" class="row dropdown-row">-->
      <!--             v-if="anonym"-->
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.name') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputName" :state="nameState" v-on:input="this.nameInput"  v-model="model.name"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.surname') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputSurname" :state="surnameState" v-on:input="this.surnameInput"  v-model="model.surname"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.company') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputCompany" :state="companyState" v-on:input="this.companyInput"  v-model="model.company"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.street') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputStreet" :state="streetState" v-on:input="this.streetInput"  v-model="model.street"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.zip') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputZip" :state="zipState" v-on:input="this.zipInput"  v-model="model.zip"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.city') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputCity" :state="cityState" v-on:input="this.cityInput"  v-model="model.city"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.countrie') }}
        </div>
        <div class="col-lg-6">
          <b-form-select v-model="model.country" ref="inputCountry" v-on:input="this.countryInput"  :state="countryState"  size="sm" :options="$t('countries.all')"></b-form-select>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6" style="float: left; line-height: 26px">
          {{ $t('quotation.mail') }}
        </div>
        <div class="col-lg-6" style="float: right">
          <b-form-input size="sm" ref="inputMail" v-on:input="this.mailInput" :state="mailState" v-model="model.quotationMail"></b-form-input>
          <!--                        <b-form-input id="quotationMail" type="email" path="quotationMail" required="true" disabled="${!user.isAnonym()}"-->
          <!--                                                        class="span2" style="width: -webkit-fill-available" value="${user.getEMailAdresse()}"/>-->
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.phone') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputPhone" :state="phoneState" v-on:input="this.phoneInput"  v-model="model.phone"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row">
        <div class="col-lg-6" style="float: left; line-height: 26px">
          {{ $t('quotation.amouth') }}
        </div>
        <div class="col-lg-6" style="float: right">
          <b-form-input size="sm" v-model="model.menge" type="number"></b-form-input>
          <!--                                            <form:input id="quotationMenge" type="number" path="menge" class="span2" style="width: -webkit-fill-available"/>-->
        </div>
      </div>
      <div class="row dropdown-row" style="padding-bottom: 0px">
        <div class="col-lg-12">
          {{ $t('quotation.comment') }}
        </div>
      </div>
      <div class="row dropdown-row" style="padding-top: 0px">
        <div class="col-lg-12">
          {{model.comment}}
          <b-form-textarea rows="4" v-model="model.kommentar">
          </b-form-textarea>
        </div>
      </div>
      <div class="row dropdown-row" style="padding-bottom: 0px" v-if="anonym">
        <div class="termsdesc col-lg-12">
          {{$t('dsgvo.preLink')}}<a :href="$t('dsgvo.link')" target="_blank">{{$t('dsgvo.link')}}</a>{{$t('dsgvo.postLink')}}
        </div>
      </div>
      <div class="row dropdown-row" style="padding-top: 5px" v-if="anonym">
        <div class="col-lg-12">
          <b-form-checkbox ref="inputTerms" v-on:input="termsInput" :state="termsState" v-model="termsChecked" name="checkbox-terms">
            {{$t('dsgvo.accept')}}
          </b-form-checkbox>
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
            variant="primary"
            class="float-right"
            @click="handleOK">
          {{$t('quotation.quotationLong')}}
        </b-button>
        <b-button
            style="margin-right: 10px"
            variant="secondary"
            class="float-right"
            @click="handleCancel">
          {{$t('general.cancel')}}
        </b-button>
      </div>
    </template>
  </b-modal>
  <!--    </div>-->
</template>

<script>

import matomoTracking from "@/mixins/matomoTracking";

export default {
  name: "RequestQuotation",
  props: ['model'],
  mixins: [matomoTracking],
  data() {
    return {
      laender:  this.$t('countries.all'),
      countryState: null,
      mailState: null,
      nameState: null,
      surnameState: null,
      phoneState: null,
      companyState: null,
      streetState: null,
      zipState: null,
      cityState: null,
      termsState: null,
      termsChecked: false
    }
  },
  computed: {
    isVisible: function () {
      return this.$store.getters.isQuotationModalVisible === true;
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
  },
  methods: {
    handleOK() {
      this.trackEvent('Konfigurator', 'Angebot angefragt')
      if (this.anonym) {
        if (!(this.$refs.inputCountry.value == null) &&
            !(this.$refs.inputName.value == null) &&
            !(this.$refs.inputSurname.value == null) &&
            !(this.$refs.inputCompany.value == null) &&
            !(this.$refs.inputStreet.value == null) &&
            !(this.$refs.inputZip.value == null) &&
            !(this.$refs.inputCity.value == null) &&
            this.mailIsValid() &&
            this.termsAccepted()) {

          this.$store.dispatch('saveKonfigForQuotation', this.model);
          this.$store.commit('setShowQuotationModal', false);
        } else {
          if (this.$refs.inputCountry.value == null || this.$refs.inputCountry.value.length === 0) {
            this.countryState = false;
          }
          if (this.$refs.inputName.value == null || this.$refs.inputName.value.length === 0) {
            this.nameState = false
          }
          if (this.$refs.inputSurname.value == null || this.$refs.inputSurname.value.length === 0) {
            this.surnameState = false
          }
          if (this.$refs.inputCompany.value == null || this.$refs.inputCompany.value.length === 0) {
            this.companyState = false
          }
          if (this.$refs.inputStreet.value == null || this.$refs.inputStreet.value.length === 0) {
            this.streetState = false
          }
          if (this.$refs.inputZip.value == null || this.$refs.inputZip.value.length === 0) {
            this.zipState = false
          }
          if (this.$refs.inputCity.value == null || this.$refs.inputCity.value.length === 0) {
            this.cityState = false
          }
          if (!this.mailIsValid()) {
            this.mailState = false;
          }
          if (!this.termsAccepted()) {
            this.termsState = false;
          }
        }
      } else {
        this.$store.dispatch('saveKonfigForQuotation', this.model);
        this.$store.commit('setShowQuotationModal', false);
      }
    },
    termsAccepted() {
      return this.termsChecked || !this.anonym;
    },
    mailIsValid() {
      if (this.$refs.inputMail.value !== null) {
        if (this.$refs.inputMail.value.indexOf("@") !== -1 && this.$refs.inputMail.value.indexOf(".") !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    },
    handleCancel() {
      this.$store.commit('setShowQuotationModal', false);
    },
    showup() {
    },

    mailInput() {
      this.mailState = null
    },
    countryInput() {
      this.countryState = null
    },
    nameInput() {
      this.nameState = null
    },
    surnameInput() {
      this.surnameState = null
    },
    companyInput() {
      this.companyState = null
    },
    streetInput() {
      this.streetState = null
    },
    zipInput() {
      this.zipState = null
    },
    cityInput() {
      this.cityState = null
    },
    phoneInput() {
      this.phoneState = null
    },
    termsInput() {
      this.termsState = null
    },
    test() {
      this.countryState = null;
    }
  }
}
</script>

<style scoped>
.row {
  padding-bottom: 10px;
}
.termsdesc {
  font-size: smaller;
}
</style>